import {Injectable} from '@angular/core';
import {GraphicComponentView} from '../../classes/graphic-component-view/graphic-component-view';
import {ILocalStorageViewsService} from './ILocalStorageViewService';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageViewsNoPersistenceService implements ILocalStorageViewsService {

  public keyForLocalStorage = 'savedViews_'; // constant
  public viewsInLocaleStorage = [];
  public maximumArraySize = 0;

  getGraphicalComponentViews(projectId: number) {
    return [];
  }

  getGraphicalComponentView(projectId: number, currentIndex: number) {
    return null;
  }

  setGraphicalComponentViews(graphicComponentView: GraphicComponentView, currentIndex: number, projectId: number) {
    return -1;
  }

  getCurrentIndex(projectId: number) {
    return -1;
  }

  changeIndex(front: boolean = true, projectId, currentIndex) {
    return -1;
  }

  deleteViews(projectId) {
  }
}
